import {Button} from 'antd';
import Form from 'antd/es/form';
import React, {useRef} from 'react';

import {DynamicIcon} from 'components/dynamic-icon';
import {OrganizationStructureTabKeys as FormKeys} from 'pages/ais/organization-structure/organization-structure-page.constants';
import {
    IAddItemButtonRef,
    IOrgStructureTabProps,
} from 'pages/ais/organization-structure/organization-structure-page.types';
import {ParticipantsList} from 'pages/ais/organization-structure/tabs/participants-tab/participants-list/participants-list';

interface IParticipantsTabProps extends IOrgStructureTabProps, Pick<IOrgStructureTabProps, 'isDisabled'> {}

export const ParticipantsTab = ({buttonsBar, isDisabled}: IParticipantsTabProps) => {
    const addBtnRef = useRef<IAddItemButtonRef>(null);

    return (
        <>
            {buttonsBar?.((
                <Button
                    type="default"
                    onClick={() => addBtnRef.current?.add()}
                >
                    <DynamicIcon type="PlusCircleOutlined" />
                    Добавить
                </Button>
            ))}
            <div>
                <Form.List
                    name={FormKeys.participants}
                >
                    {(fields, operation, {errors}) => (
                        <ParticipantsList
                            fields={fields}
                            operations={operation}
                            errors={errors}
                            isDisabled={isDisabled}
                            ref={addBtnRef}
                        />
                    )}
                </Form.List>
            </div>
        </>
    );
};
